import TextAndIconButton, { TEST_ID } from './TextAndIconButton'
import type { Props as TextAndIconButtonProps } from './TextAndIconButton'

const TextAndIconButtonComponent = TextAndIconButton

export { TEST_ID, TextAndIconButtonProps }

export default TextAndIconButtonComponent
